import { render, staticRenderFns } from "./CostSummaryTable.vue?vue&type=template&id=6f853177&scoped=true&"
import script from "./CostSummaryTable.vue?vue&type=script&lang=js&"
export * from "./CostSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./CostSummaryTable.vue?vue&type=style&index=0&id=6f853177&prod&scoped=true&lang=css&"
import style1 from "./CostSummaryTable.vue?vue&type=style&index=1&id=6f853177&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f853177",
  null
  
)

export default component.exports